import { breakpoints } from './utils/breakpoints';

class Footer {
    constructor() {
        this.class = {
            module: '.footer',
            footerLinkTitleWrapper: '.footer-link__title-wrapper',
            footerLinkGroup: '.footer-link__group',
        };

        this.toggleHandler = this.toggleHandler.bind(this);

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.init();
            }, false);
        } else {
            this.init();
        }
    }

    init() {
        this.checkViewportWidth();
        window.addEventListener('resize', this.checkViewportWidth.bind(this));
    }

    checkViewportWidth() {
        if (window.innerWidth <= breakpoints.md) {
            this.attachEventListeners();
        } else {
            this.removeEventListeners();
        }
    }

    attachEventListeners() {
        const module = document.querySelector(this.class.module);
        if (!module) return;

        const linkTitleWrappers = module.querySelectorAll(this.class.footerLinkTitleWrapper);

        linkTitleWrappers.forEach(wrapper => {
            wrapper.addEventListener('click', this.toggleHandler);
        });
    }

    removeEventListeners() {
        const module = document.querySelector(this.class.module);
        if (!module) return;

        const linkTitleWrappers = module.querySelectorAll(this.class.footerLinkTitleWrapper);

        linkTitleWrappers.forEach(wrapper => {
            wrapper.removeEventListener('click', this.toggleHandler);
        });
    }

    toggleHandler(event) {
        const module = document.querySelector(this.class.module);
        if (!module) return;

        const clickedWrapper = event.currentTarget;
        const group = clickedWrapper.nextElementSibling;

        if (group && module.contains(group) && group.classList.contains(this.class.footerLinkGroup.substring(1))) {
            clickedWrapper.classList.toggle('open');
            group.classList.toggle('open');
        }
    }
}

export default new Footer();
